import { z } from 'zod';
import {
    CarBodyType,
    CarDriveType,
    CarEngineType,
    CarPhoto,
    CarPhotoSchema,
    CarTransmissionType,
} from '@/types/car.type.ts';

export type ReportCar = {
    id: number,
    brand_name: string,
    model_name: string,
    model_code_name: string | null,
    vin: string,
    body_type: CarBodyType,
    body_color: string,
    engine_type: CarEngineType,
    transmission_type: CarTransmissionType,
    drive_type: CarDriveType,
    engine_volume: number,
    engine_power: number,
    production_year: number,
    mileage: number,
    photos: CarPhoto[],
};

export const ReportCarSchema = z.object({
    id: z.number(),
    brand_name: z.string(),
    model_name: z.string(),
    model_code_name: z.string().optional().nullable(),
    vin: z.string(),
    body_type: z.nativeEnum(CarBodyType),
    body_color: z.string(),
    engine_type: z.nativeEnum(CarEngineType),
    transmission_type: z.nativeEnum(CarTransmissionType),
    drive_type: z.nativeEnum(CarDriveType),
    engine_volume: z.number(),
    engine_power: z.number(),
    production_year: z.number(),
    mileage: z.number(),
    photos: CarPhotoSchema.array(),
});
